<script setup lang="ts">
import { AppFlicker } from '@libs/ui';

import type { ItinerarySimpleTransportSegment } from '../../models';
import { getTransportTypeForItinerarySimpleTransportSegment } from '../../stores/tripOverviewSegments/tripOverviewStoreSegmentsLogic';
import { useTripOverviewPageStore } from '../../stores';

import ItineraryTransportSelector from './ItineraryTransportSelector.vue';
import ItineraryTimeline from './ItineraryTimeline.vue';

interface ItinerarySimpleTransportSegmentProps {
  segment: ItinerarySimpleTransportSegment;
  printMode: boolean;
}

const props = defineProps<ItinerarySimpleTransportSegmentProps>();

const tripOverviewPageStore = useTripOverviewPageStore();
</script>

<template>
  <ItineraryTimeline :segment-type="segment.segmentType">
    <template #dropdown>
      <ItineraryTransportSelector
        :transport-type="
          getTransportTypeForItinerarySimpleTransportSegment(
            props.segment.segmentType
          )
        "
        :disabled="props.printMode"
        @select-transport="
          tripOverviewPageStore.selectTransport(segment, $event)
        "
      />
    </template>
    <template #header>
      <div class="itinerary-simple-transport-segment">
        <div
          v-if="tripOverviewPageStore.isLoadingSimpleTransportSegmentDetails"
          class="transport-details-loader"
        >
          <AppFlicker
            height="spacing-12"
            width="spacing-48"
            border-radius="border-radius-8"
          />
          <AppFlicker
            height="spacing-12"
            width="spacing-48"
            border-radius="border-radius-8"
          />
        </div>

        <div v-else-if="props.segment.transport" class="transport-details">
          <div>{{ props.segment.transport.distance }}</div>
          <div>{{ props.segment.transport.time }}</div>
        </div>
      </div>
    </template>
  </ItineraryTimeline>
</template>

<style scoped lang="scss">
.itinerary-simple-transport-segment {
  display: flex;
  align-items: center;
  gap: var(--spacing-32);
  margin-left: var(--spacing-16);

  .transport-message {
    @include font-label-s-light;
    white-space: nowrap;
  }

  .transport-details,
  .transport-details-loader {
    display: flex;
    gap: var(--spacing-32);
    @include font-label-s-light;
    white-space: nowrap;
  }
}
</style>
